<template>
  <div class="max-w-screen min-h-screen flex flex-col">
    <NuxtLoadingIndicator />
    <section class="header" :style="{ backgroundColor: bgColor }">
      <slot name="header">
        <LayoutBaseHeader
          :logo-path="header?.logoPath ?? ''"
          :title="header?.title ?? ''"
          :sub-title="header?.subTitle ?? ''"
          class="h-[148px] relative w-full"
          :dir="appStore?.dir"
          :style="{ backgroundColor: bgColor }"
        ></LayoutBaseHeader>
      </slot>
    </section>
    <section class="main flex-1 flex flex-col">
      <slot></slot>
    </section>
    <section class="footer">
      <slot name="footer">
        <LayoutBaseFooter :bg-color="bgColor"></LayoutBaseFooter>
      </slot>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useApp } from '@/store/useApp'; // Adjusted the path to the correct location

const appStore = useApp();

withDefaults(
  defineProps<{
    bgColor?: string;
    header?: { logoPath?: string; title?: string; subTitle?: string };
  }>(),
  { bgColor: '#2C9EB3' }
);
</script>

<style scoped>
.balanced {
  text-wrap: balance;
}
</style>
